import { FunctionComponent, createContext, useContext } from "react";
import { useLocation } from "react-router-dom";
import { generateTrackData, sendTrackData } from "../../utils/track-data";
import {
  ErrorAnalyticsContextProps,
  ErrorAnalyticsProviderProps,
} from "./error-segment.types";

const ErrorAnalyticsContext = createContext({} as ErrorAnalyticsContextProps);

export const ErrorAnalyticsProvider: FunctionComponent<
  ErrorAnalyticsProviderProps
> = ({ children }) => {
  const { pathname } = useLocation();

  const trackError: ErrorAnalyticsContextProps["trackError"] = (
    eventName,
    data,
  ) => {
    const trackData = generateTrackData({
      ...data,
      urlPage: pathname,
      origin: "myoffice",
      value: {
        ...data?.value,
      },
    });

    sendTrackData({ eventName, ...trackData });
  };

  return (
    <ErrorAnalyticsContext.Provider
      value={{
        trackError,
      }}
    >
      {children}
    </ErrorAnalyticsContext.Provider>
  );
};

export const useErrorAnalytics = () => useContext(ErrorAnalyticsContext);
